/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';

import { useProductListData } from '../api/getProductList';
import { ProductListContext } from '../ProductListContext';

export const ProductListProvider = ({ children }: { children: React.ReactNode }) => {
  const results = useProductListData();
  return <ProductListContext value={results}>{children}</ProductListContext>;
};
